import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';

import * as Highcharts from 'highcharts';

import { DaughterEligibilityComponent, SonEligibilityComponent, WifeEligibilityComponent, FatherEligibilityComponent, MotherEligibilityComponent, HusbandEligibilityComponent } from '../eligibility';

@Component({
  selector: 'app-step2',
  providers: [DaughterEligibilityComponent, SonEligibilityComponent, WifeEligibilityComponent, FatherEligibilityComponent, MotherEligibilityComponent, HusbandEligibilityComponent],
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.scss']
})
export class Step2Component implements OnInit {

	Highcharts: typeof Highcharts = Highcharts; // required
	chartOptions: Highcharts.Options;
  deceased = this.appState.get();

  // Chart Variables
  colors = Highcharts.getOptions().colors;
  activeColor = "#0F9D58";
  inactiveColor = "#cccccc";
  notEligibleColor = "#DD7E6B";
  categories = [];

  firstChart = [];
  wifeChart = [];
  wifeChartMovable = [];
  Husband = [];
  HusbandMovable = [];
  CloseRelative = [];
  CloseRelativeMovable = [];

  color_iterate = 0;

  public data = [];
  public chartData = {};


  share = [];

  // Rules
  rules: any;
  notes: any;
  notes2: any;
  error: any;
  applied_rule = {};

  show_calc = "false";


  constructor(public appState: AppService, public router: Router, public http: HttpClient, 
    private wife: WifeEligibilityComponent, private husband: HusbandEligibilityComponent, private father: FatherEligibilityComponent, private mother: MotherEligibilityComponent, private daughter: DaughterEligibilityComponent, private son: SonEligibilityComponent ) {

  }

  // On Page Load
  ngOnInit() {
    
    // Reset Grandchild to Blank if Sibling information is not provided
    if( this.deceased.siblings_info != true ) {
      this.deceased.grandchild = ""; // Crucial for redirectIfNotSupported  
    }
    

    // Start Calculation
    this.calculate();
    this.eligibility_check();
  }

  /* Redirect to Not Supported if all sons ineligible and Grand Son === Yes */
  redirectToNotSupported() {
    this.router.navigate(['not-supported']);
  }

  /* Redirect to Not Supported in case of Spouse is only Eligible or Alive otherwise proceed to calculations */
  redirectIfNotSupported() {

    if( (this.eligibiliy_object["husband"] == true || this.eligibiliy_object["wife"] == true) && 
      this.eligibiliy_object["father"] != true && this.eligibiliy_object["mother"] != true && 
      this.eligibiliy_object["daughter"] != true && this.eligibiliy_object["son"] != true ) {
      
      this.router.navigate(['not-supported']);
    } else {
      this.deceased.grandchild = "false";
      this.eligibility_check();
    }

  } 



  /* 
    Eligibility Check
  */

  eligibility_check_all: boolean = true;
  all_conditions_false: boolean = true; // Used to detect if all conditions are False (All Inheritors ineligible)
  show_sibling_screen: boolean = false;
  all_children_ineligible_or_notalive: boolean = true;
  all_conditions_undefined: boolean = true;

  eligibiliy_object = {
    "wife":  undefined,
    "husband":  undefined,
    "son":  undefined,
    "daughter":  undefined,
    "father":  undefined,
    "mother":  undefined,
  };

  eligibility_check() {
    
    // True = All Eligibility Info is entered | False = All Radio buttons are set as False | Undefined = Not set
    var wifeCheck = this.wife.eligibilityCheck(this.deceased);
    var husbandCheck = this.husband.eligibilityCheck(this.deceased);
    var sonCheck = this.son.eligibilityCheck(this.deceased);
    var daughterCheck = this.daughter.eligibilityCheck(this.deceased);
    var fatherCheck = this.father.eligibilityCheck(this.deceased);
    var motherCheck = this.mother.eligibilityCheck(this.deceased);

    this.eligibiliy_object = {
      "wife":  wifeCheck,
      "husband":  husbandCheck,
      "son":  sonCheck,
      "daughter":  daughterCheck,
      "father":  fatherCheck,
      "mother":  motherCheck,
    };

    if( wifeCheck != undefined && this.all_conditions_undefined == true ) {
      this.all_conditions_undefined = false;
    }
    if( husbandCheck != undefined && this.all_conditions_undefined == true ) {
      this.all_conditions_undefined = false;
    }
    if( sonCheck != undefined && this.all_conditions_undefined == true ) {
      this.all_conditions_undefined = false;
    }
    if( daughterCheck != undefined && this.all_conditions_undefined == true ) {
      this.all_conditions_undefined = false;
    }
    if( fatherCheck != undefined && this.all_conditions_undefined == true ) {
      this.all_conditions_undefined = false;
    }
    if( motherCheck != undefined && this.all_conditions_undefined == true ) {
      this.all_conditions_undefined = false;
    }

    // Grand Children Eligibility Check in case all Sons are ineligible
    if (this.deceased.son.count > 0 && this.all_conditions_undefined == false ) {

      for (var k = 0; k < this.deceased['son'].count; ++k) {
        var eligibility = this.deceased['son'].object[k].eligibility;
        if( eligibility == "true" && this.all_children_ineligible_or_notalive == true ) {
          this.all_children_ineligible_or_notalive = false;
        }
      }

    }

    if (this.deceased.daughter.count > 0 && this.all_conditions_undefined == false ) {

      for (var k = 0; k < this.deceased['daughter'].count; ++k) {
        var eligibility = this.deceased['daughter'].object[k].eligibility;
        if( eligibility == "true" && this.all_children_ineligible_or_notalive == true ) {
          this.all_children_ineligible_or_notalive = false;
        }
      }

    }
    
    // Show Calculate Button
    if( 
      (this.deceased.gender == 'Male' && this.deceased.wife.level1_wives.length > 0 && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '' && wifeCheck == undefined) || 
      
      (this.deceased.gender == 'Female' && (this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != 'Other' && this.deceased.martial_status != '') && 
        ( this.deceased.martial_status != "Divorced" || 
          (this.deceased.martial_status == "Divorced" && 
            (this.deceased.husband.wife_in_iddah == "true" && this.deceased.husband.divorce_rijee == "true")
          )
        ) && husbandCheck == undefined) || 

        (this.deceased.father.alive == "true" && fatherCheck == undefined) || (this.deceased.mother.alive == "true" && motherCheck == undefined) || 
        (this.deceased.son.count > 0 && sonCheck == undefined) || (this.deceased.daughter.count > 0 && daughterCheck == undefined)
     ) {
      this.eligibility_check_all = false;
    
    } else{
      this.eligibility_check_all = true;  
    }


    // Check if all conditions are false
    // Wife Alive?
    if( this.deceased.gender == 'Male' && this.deceased.wife.level1_wives.length > 0 && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '' && wifeCheck != false ) {
      this.all_conditions_false = false;
    }

    // Husband Alive?
    if( this.deceased.gender == 'Female' && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != 'Other' && this.deceased.martial_status != '' && husbandCheck != false ) {
      this.all_conditions_false = false;
    }

    // Father Alive?
    if( this.deceased.father.alive == "true" && fatherCheck != false ) {
      this.all_conditions_false = false;
    }

    // Mother Alive?
    if( this.deceased.mother.alive == "true" && motherCheck != false ) {
      this.all_conditions_false = false;
    }

    // Son Alive?
    if( this.deceased.son.count > 0 && sonCheck != false ) {
      this.all_conditions_false = false;
    }

    // Daughter Alive?
    if( this.deceased.daughter.count > 0 && daughterCheck != false ) {
      this.all_conditions_false = false;
    }


    // Show Sibling Screen
    this.siblingScreenCheck();  
    
  }

  /* Sibling Check */
  siblingScreenCheck() {
    var fatherCheck = this.father.eligibilityCheck(this.deceased);
    var motherCheck = this.mother.eligibilityCheck(this.deceased);
    var wifeCheck = this.wife.eligibilityCheck(this.deceased);
    var husbandCheck = this.husband.eligibilityCheck(this.deceased);

    var eligibleWifeCount = this.wifeElCount();
    var eligibleSonCount = this.daughterSonElCount('son');
    var eligibleDaughterCount = this.daughterSonElCount('daughter');
    


    if( 
      /* Condition#1 */
      ( 
        (this.deceased.son.count == 0 || eligibleSonCount == 0) && 
        (this.deceased.daughter.count == 0 || eligibleDaughterCount == 0) && 
        (this.deceased.father.alive == "true" && fatherCheck == true) &&
        (this.deceased.mother.alive == "true" && motherCheck == true) &&
        (
          (this.deceased.gender == 'Male' && eligibleWifeCount > 0 && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '') ||
          (this.deceased.gender == 'Female' && (this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != 'Other' && this.deceased.martial_status != '') && 
            ( this.deceased.martial_status != "Divorced" || 
              (this.deceased.martial_status == "Divorced" && 
                (this.deceased.husband.wife_in_iddah == "true" && this.deceased.husband.divorce_rijee == "true")
              )
            ) && husbandCheck == true
          ) ||
          ( (husbandCheck == undefined || husbandCheck == false) && (wifeCheck == undefined || eligibleWifeCount == 0) )
        )
      ) ||
      /* Condition#2 */
      (
        (this.deceased.son.count == 0 || eligibleSonCount == 0) && 
        (this.deceased.daughter.count == 1 || eligibleDaughterCount == 1) &&
        (this.deceased.father.alive == "true" && fatherCheck == true) &&
        (this.deceased.mother.alive == "true" && motherCheck == true) && 
        ( (husbandCheck == undefined || husbandCheck == false) && (wifeCheck == undefined || eligibleWifeCount == 0) )
      ) ||
      /* Condition#3 */
      (
        (this.deceased.son.count == 0 || eligibleSonCount == 0) && 
        (this.deceased.father.alive == "true" && fatherCheck == true) &&
        (this.deceased.mother.alive == "true" && motherCheck == true) && 
        (this.deceased.daughter.count == 1 || eligibleDaughterCount == 1) && 
        (this.deceased.gender == 'Male' && eligibleWifeCount > 0 && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '')
      )
    ) {


        if(this.eligibility_check_all== true && this.all_conditions_false != true && this.all_children_ineligible_or_notalive == true) {

          if( this.deceased.grandchild =='false' ) {
            this.show_sibling_screen = true;      
          } else {
            this.show_sibling_screen = false;      
          }
        
        } else {
          this.show_sibling_screen = true;
        }
    }
  }

  /* Eligible Son/Daughter Count */ 
  daughterSonElCount(relativeObj) {

      var relative = relativeObj;

      if (this.deceased[relative].count > 0 ) {
        var total_count = 0;

        for (var k = 0; k < this.deceased[relative].count; ++k) {
          var eligibility = this.deceased[relative].object[k].eligibility;
          if( eligibility == "true" ) {
              total_count++;
          }
        }

        // Delete Uneligible Array Values
        if( total_count != this.deceased[relative].count ) {
          return total_count;
        } else {
          return this.deceased[relative].count
        }
      } else {
        return undefined;
      }
  }

  /* Eligible wife count (for Sibling Calculation) */
  wifeElCount() {

    var wifeCheck = this.wife.eligibilityCheck(this.deceased); 

    if( this.deceased.wife.level1_wives.length > 0 && wifeCheck != undefined ) {

      var total_count = 0;
      var relativeObj = this.deceased.wife.level1_wives;
      for (var i = 0; i < relativeObj.length; ++i) {

          var eligibility = this.deceased.wife.level1_wives[i].eligibility;
          if( eligibility == "true" ) {
              total_count++;
          } else {
            var object = {"name": this.deceased.wife.level1_wives[i].name, "relation": "wife"};
          }
      }
      
      return total_count;  
    
    }

    return undefined;
    
  }

  /* Title for Chart and Table */
  praseLabelTitle(title: string) {
    title = title.replace("_", " ");

    if( title == "son" ) {
      title = "S";
    } else if( title == "daughter" ) {
        title = "D";
    } else if( title == "father" ) {
        title = "F";
    } else if( title == "mother" ) {
        title = "M";
    } else if( title == "husband" ) {
        title = "H";
    }

    title = title.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});

    return title;
  }

  /* Calculate Button */
  calculate() { 
    this.calculateShare(); // Calculate Share %
    this.drawPossibleInheritors();
    this.createTable(); // Create Legend Table
  }


  /* Calculate Share */
  calculateShare() {

    this.categories = [];
    this.data = [];

    this.firstChart = [];
    this.wifeChart = [];
    this.Husband = [];
    this.CloseRelative = [];

    this.color_iterate = 0;


    // Calculate Alive Relatives for Outer Pie ring
    var graphAliveRelations = ['father', 'mother', 'son', 'daughter'];
    var AliveCount = 0;
    for (var gi = 0; gi < graphAliveRelations.length; ++gi) {
      var giKey = graphAliveRelations[gi];
      
      if( giKey == "father" || giKey == "mother" ) {
        if( this.deceased[giKey].alive == "true" ) {
          AliveCount++;
        }
      } else {
        if( this.deceased[giKey].count > 0 ) {
          AliveCount += this.deceased[giKey].count;
        }
      }
    }


    ////////// Father & Mother ///////////
    var relObject = ['father', 'mother'];

    for (var iteration = 0; iteration < relObject.length; ++iteration) {
      var key_name = relObject[iteration];

      if( this.deceased[key_name].alive == "true" ) {

          var object = {};
          object["y"] = 100/AliveCount;
          object["id"] = key_name;
          object["sub_id"] = "";

          object["real_name"] =  this.deceased[key_name].name;
          object["eligibility"] =  this.deceased[key_name].eligibility;

          // Chart Pie Color
          if( this.deceased[key_name].eligibility == "true" ) {
            object["color"] =  this.activeColor;
            object["active"] = true;
          
          } else if( this.deceased[key_name].eligibility == "false" ) {
            object["color"] =  this.notEligibleColor;
            object["active"] = false;
          
          } else {
            object["color"] =  this.inactiveColor;
            object["active"] = "";
          }

          object["name"] = this.praseLabelTitle(key_name);

          this.CloseRelative.push(object);
      }
    

    }
    

    ///////// Son or Daughter //////////
    var relObject = ['son', 'daughter'];

    if( this.deceased.survivors != 'false' ) {

      for (var iteration = 0; iteration < relObject.length; ++iteration) {
        var key_name = relObject[iteration];

        if( this.deceased[key_name].count > 0 ) {

            var total_ppl_count = this.deceased[key_name].count;
            
            for (var i: number = 0; i < total_ppl_count; ++i) {

              var object = {};
              object["y"] = 100/(AliveCount);
              object["id"] =  key_name;

              object["real_name"] =  this.deceased[key_name]['object'][i].name;
              object["eligibility"] =  this.deceased[key_name]['object'][i].eligibility;

              // Chart Pie Color
              if( this.deceased[key_name]['object'][i].eligibility == "true" ) {
                object["color"] =  this.activeColor;
                object["active"] = true;
              
              } else if( this.deceased[key_name]['object'][i].eligibility== "false" ) {
                object["color"] =  this.notEligibleColor;
                object["active"] = false;
              
              } else {
                object["color"] =  this.inactiveColor;
                object["active"] = "";
              }
              
              
              object["name"] = this.praseLabelTitle(key_name) + ( total_ppl_count > 1 ? "" + (i + 1) : '');
              object["sub_id"] =  i + 1;

              this.CloseRelative.push(object);

              this.color_iterate++;
            }
        }
      } // Endforeach [Son, Daughter]

    }


    ///////// Husband //////////
    if( this.deceased.gender == 'Female' &&  
      ( this.deceased.martial_status == 'Permanent' || 
        (this.deceased.martial_status == "Divorced" && 
          (this.deceased.husband.wife_in_iddah == "true" && this.deceased.husband.divorce_rijee == "true")
        ) 
      ) 
    ) {
      key_name = "husband";

      var object = {};
      object["y"] = 1;
      object["id"] = key_name;
      object["sub_id"] = "";

      object["real_name"] =  this.deceased[key_name].name;
      object["eligibility"] =  this.deceased[key_name].eligibility;

      // Chart Pie Color
      if( this.deceased[key_name].eligibility == "true" ) {
        object["color"] =  this.activeColor;
        object["active"] = true;
      
      } else if( this.deceased[key_name].eligibility == "false" ) {
        object["color"] =  this.notEligibleColor;
        object["active"] = false;
      
      } else {
        object["color"] =  this.inactiveColor;
        object["active"] = "";
      }

      object["name"] = this.praseLabelTitle(key_name);
      this.Husband.push(object);

    }



    ///////// Wife //////////
    if( this.deceased.gender == 'Male' && this.deceased.wife.level1_wives.length > 0 && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '' ) {

      for (var i: number = 0; i < this.deceased.wife.level1_wives.length; ++i) {
        var object = {};
        object["y"] = 100/this.deceased.wife.level1_wives.length;
        object["id"] =  "wife";
        object["real_name"] =  this.deceased.wife.level1_wives[i].name;
        object["eligibility"] =  this.deceased.wife.level1_wives[i].eligibility;

        // Chart Pie Color
        if( this.deceased.wife.level1_wives[i].eligibility == "true" ) {
          object["color"] =  this.activeColor;
          object["active"] = true;
        
        } else if( this.deceased.wife.level1_wives[i].eligibility== "false" ) {
          object["color"] =  this.notEligibleColor;
          object["active"] = false;
        
        } else {
          object["color"] =  this.inactiveColor;
          object["active"] = "";
        }

        // Wife Label Type<Permanent|Iddah|Sick>
        if( this.deceased.wife.level1_wives[i].type == "permanent" ) {
          var wifeLabel = "PW";
        
        } else if( this.deceased.wife.level1_wives[i].type == "iddah" ) {
          var wifeLabel = "IW";
        
        } else if( this.deceased.wife.level1_wives[i].type == "sick" ) {
          var wifeLabel = "DW";
        }

        object["table_name"] = object["name"] = wifeLabel + (i + 1);
        object["sub_id"] =  i + 1;

        this.wifeChart.push(object);

        this.color_iterate++;
      }

    }
  }



  /* 
    Create Legend Table
  */

  finalTable = [];

  createTable() {
    
    this.finalTable = [];
    for (var i = 0; i < this.CloseRelative.length; ++i) {

        var tableObj = {
          'symbol': this.CloseRelative[i].name,
          'relation': this.CloseRelative[i].id,
          'name': this.CloseRelative[i].real_name
        };

        this.finalTable.push(tableObj);
    }

    // Husband
    for (var i = 0; i < this.Husband.length; ++i) {

        var tableObj = {
          'symbol': this.Husband[i].name,
          'relation': this.Husband[i].id,
          'name': this.Husband[i].real_name
        };

        this.finalTable.push(tableObj);
    }


    // Wife
    for (var i = 0; i < this.wifeChart.length; ++i) {

        var tableObj = {
          'symbol': this.wifeChart[i].name,
          'relation': this.wifeChart[i].id,
          'name': this.wifeChart[i].real_name
        };

        this.finalTable.push(tableObj);
    }
  }


  // Draw Possible Inheritors
  drawPossibleInheritors() {
    this.colors = Highcharts.getOptions().colors;

    this.firstChart = [{
      y: 100,
      name: "",
      color: "#ffffff"
    }];

    this.chartData = {
        chart: {
          //width: 1000,
          height: window.innerHeight-200,
          type: 'pie',
          margin: [0, 0, 0, 0]
        },

        title: {
            text: ''
        },

        yAxis: {
            title: {
                text: 'Total percent'
            }
        },
        plotOptions: {
            pie: {
              slicedOffset: 0,
              size:'100%',
              shadow: false,
              center: ['50%', '50%'],
            }
        },
        tooltip: {
            enabled: false,
            valueSuffix: '%'
        },
        series: []
    };

    // Add Chart to Display
    this.chartData["series"] = [];

    // 1st Tier
    this.chartData["series"].push({
        name: 'Deceased Person',
        data: this.firstChart,
        size: '25%',
        dataLabels: {
            formatter: function () {
                return this.point.name;
            },
            color: '#ffffff',
            distance: -50
        },

        events: {           
        }
    });


    // 2nd Tier
    if( this.wifeChart.length > 0 ) {
      this.chartData["series"].push({
        name: 'Wife (Immovable)',
        data: this.wifeChart,
        size: '60%',
        innerSize: '50%',
        
        dataLabels: {
            formatter: function () {
                return this.point.name;
            },
            distance: -30
        },

        events: {
            click: function (e) {
                var link = "/#/eligibility/"+e.point.options.id;
                if( e.point.options.sub_id ) {
                  link += "#r"+e.point.options.sub_id
                }
                window.location.href = link;
            }            
        }
      });
    }

    // 2th Tier (Husband)
    if( this.Husband.length > 0 ) {
      this.chartData["series"].push({
        name: 'Husband',
        data: this.Husband,
        size: '60%',
        innerSize: '50%',
        
        dataLabels: {
            formatter: function () {
                return this.point.name;
            },
            distance: -30
        },

        events: {
            click: function (e) {
                var link = "/#/eligibility/"+e.point.options.id;
                if( e.point.options.sub_id ) {
                  link += "#r"+e.point.options.sub_id
                }
                window.location.href = link;
            }            
        }
      });
    }

    // 3rd Tier
    if( this.CloseRelative.length > 0) {
      this.chartData["series"].push({
          name: 'Close Relatives',
          data: this.CloseRelative,
          size: this.Husband.length > 0 || this.wifeChart.length > 0 ? '100%' : '75%',
          innerSize: this.Husband.length > 0 || this.wifeChart.length > 0 ? '60%' : '30%',
          dataLabels: {
              formatter: function () {
                  return this.point.name;
              },
              distance: -38
          },

          events: {
            click: function (e) {
              var link = "/#/eligibility/"+e.point.options.id;
              if( e.point.options.sub_id ) {
                link += "#r"+e.point.options.sub_id
              }
              window.location.href = link;
            }            
          }
      });
    }
  }


  getResults(event) {
    // Save Values
    this.appState.set(this.deceased);

    var wifeCheck = this.wife.eligibilityCheck(this.deceased);
    var husbandCheck = this.husband.eligibilityCheck(this.deceased);
    var sonCheck = this.son.eligibilityCheck(this.deceased);
    var daughterCheck = this.daughter.eligibilityCheck(this.deceased);
    var fatherCheck = this.father.eligibilityCheck(this.deceased);
    var motherCheck = this.mother.eligibilityCheck(this.deceased);

    if( wifeCheck == true && 
      (husbandCheck == undefined || husbandCheck == false) && 
      (sonCheck == undefined || sonCheck == false) && 
      (daughterCheck == undefined || daughterCheck == false) &&  
      (fatherCheck == undefined || fatherCheck == false) &&  
      (motherCheck == undefined || motherCheck == false)
    ) {
      this.router.navigate(['not-supported']);
      event.preventDefault();
    
    }
    
  }

  // Back Button
  back(event) {

    if( this.deceased.gender == 'Male' && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '' ) {
      if( this.deceased.wife.divorced.count > 0 ) {
        this.router.navigate(['wife/divorced']);

      } else if( this.deceased.wife.temp.count > 0 ) {
        this.router.navigate(['wife/temp']);

      } else {
          this.router.navigate(['']);
      }

    } else {
      this.router.navigate(['']);
    }

    event.preventDefault();
  }



  // Remove Later
  eligibilityCheckAll(event) {

    // Father | Mother
    var relObject = ['father', 'mother'];
    for (var i = 0; i < relObject.length; ++i) {
      var relation = relObject[i];
      if( this.deceased[relation].alive == "true" ) {
        for (var key in this.deceased[relation]) {
          if( key != "name" && key != "alive" ) {
            this.deceased[relation][key] = "true";
          }
          
        }
      }
    }

    // Son | Daughter
    var relObject = ['son', 'daughter'];
    for (var i = 0; i < relObject.length; ++i) {
      var relation = relObject[i];
      if( this.deceased[relation].count > 0 && this.deceased[relation].object.length > 0 ) {
        for (var k = 0; k < this.deceased[relation].object.length; ++k) {
          for (var key in this.deceased[relation].object[k]) {
            if( key != "name" ) {
              this.deceased[relation].object[k][key] = "true";
            }          
          }
        }
      }
    }

    // Husband
    // if( this.deceased.gender == "Female" && this.deceased.martial_status != "Never Married" && this.deceased.martial_status != "Other" && this.deceased.martial_status != "" ) {

    if( this.deceased.gender == 'Female' &&  
      ( this.deceased.martial_status == 'Permanent' || 
        (this.deceased.martial_status == "Divorced" && 
          (this.deceased.husband.wife_in_iddah == "true" && this.deceased.husband.divorce_rijee == "true")
        ) 
      ) 
    ) {

      for (var key in this.deceased.husband) {
        if( key != "name" && key != "relation_type" && key != "inheritance_condition" && key != "wife_in_iddah" && key != "divorce_rijee" ) {
          this.deceased.husband[key] = "true";
        }
      }
    }

    // Wife
    if( this.deceased.wife.level1_wives.length > 0 ) {
      for (var i = 0; i < this.deceased.wife.level1_wives.length; ++i) {

        for (var key in this.deceased.wife.level1_wives[i] ) {
          if( key != "name" && key != "type" ) {
            this.deceased.wife.level1_wives[i][key] = "true";
          }
        }
      }
    }
  

    this.ngOnInit();

  }


}
